/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/forbid-prop-types */
import React, { forwardRef, useState } from 'react';
import PropTypes from 'prop-types';
import { AsyncPaginate } from 'react-select-async-paginate';
import './styles.scss';
import httpService from '../../services/httpService';
import useTranslation from '../../hooks/useTranslation';

export const cancelSelectPaginationValue = (selectRef, selectObject) => {
  if (selectRef.current && selectObject && selectObject.label && selectObject.value) {
    selectRef.current.select.setValue({ value: selectObject.value, label: selectObject.label });
  } else {
    selectRef.current.select.setValue('');
  }
};

export const clearSelectPaginationValue = (selectRef) => {
  if (selectRef.current) { selectRef.current.select.setValue(''); }
};

const EpSelectPagination = forwardRef(({
  inputId, labelText, selectedItem, classError, onBlur, onChange,
  placeholderText, baseUrlAPI, endpointAPI, params, hospitalName,
  optionValueProp, optionLabelProp, defaultValue, formatOptionLabel, customRef,
}) => {
  // Tags do Globalization
  const Network = useTranslation('Network');
  const Account = useTranslation('Account');

  const [reqPage, setReqPage] = useState(0);
  const [currentSearchQuery, setCurrentSearchQuery] = useState('');

  const loadOptions = async (searchQuery) => { // (searchQuery, loadedOptions, { page })
    setCurrentSearchQuery(searchQuery);

    const { get } = httpService();
    const responseJSON = await get(baseUrlAPI + endpointAPI, { ...params, Page: reqPage });

    // Transforma resposta da requisição para o padrão do react-select-async-paginate
    const optionsListFormmated = responseJSON.response.itens.map((option) => {
      const optionsList = {
        ...option,
        value: option[optionValueProp],
        label: option[optionLabelProp],
      };

      delete optionsList[optionValueProp];
      delete optionsList[optionLabelProp];

      return optionsList;
    });

    const hasMore = responseJSON.response.page < (responseJSON.response.totalPages - 1);

    if (hasMore) {
      setReqPage(reqPage + 1);
    }

    if (searchQuery !== currentSearchQuery) {
      setReqPage(0);
    }

    return {
      options: optionsListFormmated,
      hasMore,
      additional: {
        page: reqPage,
      },
    };
  };

  const selectStyles = { menuPortal: provided => ({ ...provided, zIndex: 9999 }) };

  const formatHospitalOptionLabel = ({
    hospitalCode, label, networkName, tenantName,
  }) => (
    <div className="option-label" key={hospitalCode}>
      <span className="option-label__title">{label}</span>
      <span className="option-label__subtitle">{Network}: {networkName}</span>
      <span className="option-label__subtitle">{Account}: {tenantName}</span>
    </div>
  );

  const SingleValue = () => (
    <div>
      {hospitalName}
    </div>
  );

  return (
    <>
      <label htmlFor={inputId} className="form-label">{labelText}</label>

      <AsyncPaginate
        selectRef={customRef}
        id={inputId}
        defaultValue={defaultValue}
        className={classError}
        onBlur={onBlur}
        formatOptionLabel={formatOptionLabel ? formatHospitalOptionLabel : null}
        key={JSON.stringify(selectedItem)}
        cacheOptions
        loadOptions={loadOptions}
        onChange={onChange}
        isSearchable
        placeholder={placeholderText}
        additional={{
          page: reqPage,
        }}
        styles={selectStyles}
        menuPortalTarget={document.body}
        components={hospitalName ? { SingleValue } : null}
        maxMenuHeight={150}
        menuPlacement="auto"
        menuShouldBlockScroll
      />
    </>
  );
});
export default EpSelectPagination;

EpSelectPagination.defaultProps = {
  placeholderText: null,
  defaultValue: '',
  selectedItem: '',
  params: {},
  formatOptionLabel: false,
  customRef: null,
};

EpSelectPagination.propTypes = {
  inputId: PropTypes.string.isRequired,
  labelText: PropTypes.string.isRequired,
  defaultValue: PropTypes.string,
  selectedItem: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  placeholderText: PropTypes.string,
  classError: PropTypes.string.isRequired,
  onBlur: PropTypes.func.isRequired,
  baseUrlAPI: PropTypes.string.isRequired,
  endpointAPI: PropTypes.string.isRequired,
  params: PropTypes.objectOf(PropTypes.any),
  optionValueProp: PropTypes.string.isRequired,
  optionLabelProp: PropTypes.string.isRequired,
  hospitalName: PropTypes.string.isRequired,
  formatOptionLabel: PropTypes.bool,
  customRef: PropTypes.object,
};
